const parseComponentsByCategory = (components) => {
    return components.reduce((acc, component) => {
        const { id: categoryId, typeLabelPL, typeLabelEN } = component.productCategory;
        let category = acc.find((c) => c.categoryId === categoryId);
        if (!category) {
            category = {
                categoryId,
                typeLabelEN,
                typeLabelPL,
                items: [],
            };
            acc.push(category);
        }
        category.items.push(component);
        return acc;
    }, []);
};
export default parseComponentsByCategory;
